const PollingCenterModule = () => import('./PollingCenterModule.vue')
import PollingCenterIndex from '@/modules/polling-center/views/PollingCenterIndex.vue'

export const pollingCenterModuleRoute = {
  name: 'polling-center',
  path: '/polling-center',
  component: PollingCenterModule,
  children: [
    {
      path: 'polling-centers',
      name: 'polling-centers.index',
      component: PollingCenterIndex
    }
  ]
}
